// 9fbef606107a605d69c0edbcd8029e5d
import { ACCOUNT_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const ACCOUNT_CONSTANTS = {
  GET_ACCOUNT_NAVIGATION_LIST: `${ACCOUNT_ACTION_PATTERN}GET_ACCOUNT_NAVIGATION_LIST`,
  SET_ACCOUNT_NAVIGATION_LIST: `${ACCOUNT_ACTION_PATTERN}SET_ACCOUNT_NAVIGATION_LIST`,
  GET_MODULEX_CONTENT: `${ACCOUNT_ACTION_PATTERN}GET_MODULEX_CONTENT`,
  SET_MODULEX_CONTENT: `${ACCOUNT_ACTION_PATTERN}SET_MODULEX_CONTENT`,
  SHOW_LOADER: `${ACCOUNT_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_LOADER: `${ACCOUNT_ACTION_PATTERN}HIDE_LOADER`,
  GET_ACCOUNT_NAV_LIST_TTL: 30 * 1000,
  ACCOUNT_BRAND_US: 'TCP',
  ACCOUNT_CHANNEL_US: 'Desktop',
  ACCOUNT_COUNTRY_US: 'USA',
  ACCOUNT_BRAND_CA: 'TCP',
  ACCOUNT_CHANNEL_CA: 'Desktop',
  ACCOUNT_COUNTRY_CA: 'Canada',
  ACCOUNT_SITE_US: 'us',
  ACCOUNT_SITE_CA: 'ca',
  ACCOUNT_ANALYTICS: {
    navigationText: {
      createAccount: 'header-create account',
      logIn: 'header-log in',
      welcomeMsg: 'header-welcome message',
      overview_viewProfile: 'my account-account overview-view profile',
      overview_allRewards: 'my account-account overview-view all rewards',
      overview_allExtraPoints: 'my account-account overview-view all',
      overview_viewWallet: 'my account-account overview-view my wallet',
      overview_allOrders: 'my account-account overview-view all orders',
      overview_plccOffers: 'my account-account overview-apply or accept offer',
      overview_viewPreferences: 'my account-account overview-view preferences',
      overview_viewAddressBook: 'my account-account overview-view address book',
      overview_viewPayment: 'my account-account overview-view payment or gift cards',
      shop_placeRewards: 'my account-my place rewards-shop now',
      shop_myWallet: 'my account-my wallet-shop now',
      shop_orders: 'my account-orders-shop now',
      profile_editInfo: 'my account-profile information-edit personal info',
      profile_changePassword: 'my account-profile information-change password',
      profile_addBirthday: 'my account-profile information-add birthday info',
      profile_addFavStore: 'my account-profile information-update favorite store',
      address_addNew: 'my account-address book-add new address',
      payment_addNewCard: 'my account-payment & gift cards-add new card',
      payment_addGiftCard: 'my account-payment & gift cards-add a gift card',
      preferences_edit: 'my account-my preferences-edit',
      plcc_apply: 'my account-my place rewards credit card-apply or accept offer',
      plcc_manage: 'my account-my place rewards credit card-manage credit card account',
    },
    navigationName: {
      overview_viewProfile: 'profileclickevent',
      overview_allRewards: 'rewardsclickevent',
      overview_allExtraPoints: 'earnextrapointclickevent',
      overview_viewWallet: 'walletlinksclickevent',
      overview_allOrders: 'ordersclickevent',
      overview_plccOffers: 'plccoffersclickevent',
      overview_viewPreferences: 'viewpreferencesclickevent',
      overview_viewAddressBook: 'viewaddressbookclickevent',
      overview_viewPayment: 'viewpaymentclickevent',
      shop_placeRewards: 'shopnowclickevent',
      shop_myWallet: 'walletlinksclickevent',
      shop_orders: 'shopnowclickevent',
      profile_editInfo: 'profileeditclickevent',
      profile_changePassword: 'profilechangepasswordclickevent',
      profile_addBirthday: 'profileaddbirthdayclickevent',
      profile_addFavStore: 'profileaddfavstoreclickevent',
      address_addNew: 'addressclickevent',
      payment_addNewCard: 'paymentclickevent',
      payment_addGiftCard: 'paymentclickevent',
      preferences_edit: 'editpreferencesclickevent',
      plcc_apply: 'loyaltyclick',
      plcc_manage: 'loyaltyclick',
    },
  },
  FOOTER_LINKS: 'account-footer-links',
  LEGAL_LINKS: 'account-legal-links',
  PLCC_CARDS: ['PLACE CARD', 'Placecard'],
};

export default ACCOUNT_CONSTANTS;
